import { render, staticRenderFns } from "./CotPuaListComponent.vue?vue&type=template&id=a148ac1e"
import script from "./CotPuaListComponent.vue?vue&type=script&lang=js"
export * from "./CotPuaListComponent.vue?vue&type=script&lang=js"
import style0 from "./CotPuaListComponent.vue?vue&type=style&index=0&id=a148ac1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports